import { Controller } from "@hotwired/stimulus";

// Handles visual selection state for job list items
export default class extends Controller {
  static targets = ["card"];

  connect() {
    // On page load, ensure first card is marked as selected
    if (this.hasCardTarget && this.cardTargets.length > 0) {
      this.selectCard(this.cardTargets[0]);
      // Dispatch event for first job to be added to stack
      const firstJobId = this.getJobIdFromCard(this.cardTargets[0]);
      if (firstJobId) {
        this.dispatchJobSelected(firstJobId);
      }
    }
  }

  select(event) {
    // Find the card element (the link's parent or ancestor with data-job-selection-target="card")
    const clickedCard = event.currentTarget.closest(
      '[data-job-selection-target="card"]'
    );
    if (clickedCard) {
      this.selectCard(clickedCard);

      // Dispatch event to notify stack controller
      const jobId = this.getJobIdFromCard(clickedCard);
      if (jobId) {
        this.dispatchJobSelected(jobId);
      }
    }
  }

  selectCard(card) {
    // Remove selected state from all cards
    this.cardTargets.forEach((target) => {
      target.classList.remove("border-neutral-800");
      target.classList.add("border-neutral-50");
    });

    // Add selected state to clicked card
    card.classList.remove("border-neutral-50");
    card.classList.add("border-neutral-800");
  }

  // Extract job ID from the card's link
  getJobIdFromCard(card) {
    const link = card.querySelector('a[href*="/talent/jobs/"]');
    if (link) {
      const match = link.href.match(/\/talent\/jobs\/(\d+)/);
      return match ? match[1] : null;
    }
    return null;
  }

  // Dispatch custom event for job selection
  dispatchJobSelected(jobId) {
    const event = new CustomEvent("job-selected", {
      detail: { jobId: jobId },
      bubbles: true,
    });
    this.element.dispatchEvent(event);
  }
}
